import type * as msal from '@azure/msal-browser';
import {Avatar} from '@mui/material';
import type * as React from 'react';

const getInitials = (name : string | undefined) : string | undefined => {
    if (!name) {
        return undefined;
    }

    const names = name.trim().split(' ');
    const firstName = names.shift();
    const lastName = names.pop();

    if (!firstName) {
        return undefined;
    }

    if (!lastName) {
        return firstName[0].toLocaleUpperCase();
    }

    return `${firstName[0].toLocaleUpperCase()}${lastName[0].toLocaleUpperCase()}`;
};

// Using styled API for styling
// const StyledAvatar = styled(Avatar)(({theme}) => ({
//     width: theme.spacing(4),
//     height: theme.spacing(4),
//     fontSize: theme.typography.pxToRem(15),
// }));

type Props = {
    account : msal.AccountInfo;
};

const UserAvatar : React.FC<Props> = ({account} : Props) => {
    // const msal = useMsal();
    // const [imageUrl, setImageUrl] = useState<string | null>(null);
    //
    // // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    // const graphClient : GraphClient = useMemo(
    //     () => GraphClient
    //         .initWithMiddleware({
    //             authProvider: {
    //                 getAccessToken: () => msal.getAccessToken('https://graph.microsoft.com/User.Read'),
    //             },
    //         }),
    //     [msal]
    // );
    //
    // useEffect(() => {
    //     (async () => {
    //         let photo;
    //
    //         try {
    //             photo = await graphClient.api('/me/photos/64x64/$value').get();
    //         } catch (e) {
    //             // User has no photo
    //             return;
    //         }
    //
    //         setImageUrl(URL.createObjectURL(photo));
    //     })();
    // }, [graphClient]);
    //
    // if (!imageUrl) {
    return (
        <Avatar>{getInitials(account.name)}</Avatar>
    );
    // }

    // return (
    //     <Avatar alt={getInitials(account.name)} src={imageUrl}/>
    // );
};

export default UserAvatar;
